var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "edit_svg__a",
  width: 16,
  height: 17,
  x: 0,
  y: -1,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0-.003h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#edit_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.333 12.664h.95L10.8 6.147l-.95-.95-6.517 6.517zM2 13.997v-2.833l8.8-8.783q.2-.183.442-.284.24-.1.508-.1.267 0 .517.1.249.1.433.3l.917.934q.2.183.291.433a1.44 1.44 0 0 1 0 1.008 1.25 1.25 0 0 1-.291.442l-8.784 8.783zm8.317-8.316-.467-.484.95.95z"
}))));
export default SvgEdit;